module.exports = __webpack_public_path__ + "media/img/scholarships/Maths Year 10-043cdec0cedee8a078ce67591b670e17.svg";